<script>
import {updateUser} from "@/api/accounts.js";
import {minLength, required, maxLength, alphaNum, alpha} from "vuelidate/lib/validators"
import swal from "sweetalert";

export default {
  name: "update-user-modal",
  props: ["item"],

  data() {
    return {
      form: {
        id: null,
        first_name: null,
        last_name: null,
        company_name: null,
        phone_number: null
      },
      email: null
    };
  },
  validations: {
    form: {
      first_name: {
        alphaNum,
        maxLength: maxLength(255),

      },
      last_name: {
        alphaNum,
        maxLength: maxLength(255),

      },
      company_name: {
        maxLength: maxLength(255),

      },
      phone_number: {
        required,
        alphaNum,
        maxLength: maxLength(12),
        minLength: minLength(10)
      }

    }
  },
  mounted() {
    // console.log(this.item.profile);
    this.form.first_name = null;
    this.form.last_name = null;
    this.form.company_name = null;
    this.form.phone_number = null;
    setTimeout(() => {
      // console.log(this.item.profile);
      this.form.id =
          this.item && this.item.profile ? this.item.profile.id : null;
      this.form.first_name =
          this.item && this.item.profile ? this.item.profile.first_name : null;
      this.form.last_name =
          this.item && this.item.profile ? this.item.profile.last_name : null;
      this.email =
          this.item && this.item.profile ? this.item.profile.email : null;
      this.form.company_name =
          this.item && this.item.profile ? this.item.profile.company_name : null;
      this.form.phone_number =
          this.item && this.item.profile ? this.item.profile.phone_number : null;
    }, 600);
  },
  methods: {


    handleModalClose() {
      this.$emit("close");
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        swal("Invalid", "Please fill in the accurate information");
      } else {
        const payload = JSON.parse(JSON.stringify(this.form));
        payload.email = this.item.profile.email;
        const response = await updateUser(this.item.id, payload);
        if (response && response.success) {
          swal("Success", "Successfully updated");
          setTimeout(() => {
            this.$store.dispatch("getUsers");
            this.handleModalClose();
          }, 1000);
        }
      }
    }
  }
};
</script>

<template>
  <b-modal
      id="modal-update-user"
      ref="modal-update-user"
      title="Update user"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      hide-header-close
  >
    <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        enctype="multipart/form-data"
        id="form-modal-add-user"
    >
      <b-form-group label="First Name" :class="{ 'form-group--error': $v.form.first_name.$error }">
        <b-form-input v-model.trim="$v.form.first_name.$model"></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">

          <span class="d-block p-1" v-if="!$v.form.first_name.maxLength">Field cannot exceed
            {{ $v.form.first_name.$params.minLength.min }} letters</span>
          <span class="d-block p-1" v-if="!$v.form.first_name.alphaNum">Field cannot accept special characters</span>
        </p>
      </b-form-group>

      <b-form-group label="Last Name" :class="{ 'form-group--error': $v.form.last_name.$error }">
        <b-form-input v-model.trim="$v.form.last_name.$model"></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.last_name.maxLength">Field cannot exceed
            {{ $v.form.last_name.$params.minLength.min }} letters</span>
          <span class="d-block p-1" v-if="!$v.form.last_name.alphaNum">Field cannot accept special characters</span>
        </p>
      </b-form-group>

      <b-form-group label="Email">
        <b-form-input v-model="email" required disabled></b-form-input>
      </b-form-group>
      <b-form-group label="Phone Number" :class="{ 'form-group--error': $v.form.phone_number.$error }">
        <b-form-input v-model.trim="$v.form.phone_number.$model"></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">
          <span class="d-block p-1" v-if="!$v.form.phone_number.required">Field is required</span>
          <span class="d-block p-1" v-if="!$v.form.phone_number.minLength || !$v.form.phone_number.alphaNum">Please enter a valid Phone Number</span>

        </p>
      </b-form-group>
      <b-form-group label="Company Name" :class="{ 'form-group--error': $v.form.company_name.$error }">
        <b-form-input v-model.trim="$v.form.company_name.$model"></b-form-input>
        <p style="color:#F64E60; margin-top: 5px" class="error">

          <span class="d-block p-1" v-if="!$v.form.company_name.maxLength">Field cannot exceed
            {{ $v.form.company_name.$params.maxLength.min }} letters</span>
        </p>
      </b-form-group>

      <b-button
          type="button"
          class="float-right ml-2"
          variant="danger"
          @click="handleModalClose"
      >
        Cancel
      </b-button>
      <b-button type="submit" class="float-right" variant="primary">
        Update
      </b-button>
    </b-form>
  </b-modal>
</template>
